import { API } from './../constants'
import authService from './auth.js'

let mentoriasAbiertas = null
let mentoriasCerradas = null

const mentorService = {
  async checkMentorPorId (id) {
    const fetchResponse = await fetch(`${API}/mentor/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async chequearInscripcionExamenPorPersonaIdPorServicioId (id1, id2) {
    const fetchResponse = await fetch(`${API}/check-inscipcion-examen/${id1}/${id2}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async checkInscripcionPorMentorPorPersonaId (id) {
    const fetchResponse = await fetch(`${API}/mentor-check-inscipciones/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async chequearInscripcionCompleta (id) {
    const fetchResponse = await fetch(`${API}/inscripcion-completa-examen/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async checkMostrarBotonExamenPorPersonaId (id1, id2) {
    const fetchResponse = await fetch(`${API}/inscripcion-examen-mostrar-boton/${id1}/${id2}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async checkMostrarBotonMesaDeExamenPorPersonaId (id) {
    const fetchResponse = await fetch(`${API}/mesas-de-examenes-mostrar-boton/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async traerMentoriasAbiertasPorPersonaId (id) {
    const fetchResponse = await fetch(`${API}/mentorias-abiertas/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    mentoriasAbiertas = respuesta.data
    return [...mentoriasAbiertas]
  },
  async traerMentoriasCerradasPorPersonaId (id) {
    const fetchResponse = await fetch(`${API}/mentorias-cerradas/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    mentoriasCerradas = respuesta.data
    return [...mentoriasCerradas]
  },
  crearMentor (data) {
    return fetch(`${API}/crear-mentor`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(respuesta => {
        return { ...respuesta }
      })
  }
}

export default mentorService
